<top-banner variant="title" [title]="selectedWorker ? selectedWorker.firstName + ' ' + selectedWorker.lastName : ''"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems" [backLink]="backLink ? { path: backLink, title: 'Back' } : null"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <h4 class="card-title">Sites</h4>
            <div class="mb-2 animated fadeIn">
              <div class="row">
                <div class="col-md-12">

                  <p-table [value]="sites" [autoLayout]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Site</th>
                        <th>Site Owner</th>
                        <th>Induction</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-site>
                      <tr>
                        <td *ngIf="isAdmin">
                          <a [routerLink]="['/', routeRole, 'sites', site.site.id, 'workers']">
                            {{ site.site.name }}
                          </a>
                        </td>
                        <td *ngIf="!isAdmin">{{ site.site.name }}</td>
                        <td>{{ site.site.siteOwner.firstName }} {{ site.site.siteOwner.lastName }}</td>
                        <td>
                          <span *ngIf="site.site.siteInductionCourse && site.inductionForSite && site.inductionForSite.courseProgress === TrainingCourseStateType.Completed" class="badge badge-pill badge-success">Valid until: {{ site.inductionForSite.expiryDate | date : 'mediumDate' }}</span>
                          <ng-container *ngIf="site.site.siteInductionCourse && site.inductionForSite && site.inductionForSite.courseProgress === TrainingCourseStateType.Expired">
                            <span class="badge badge-pill badge-warning">Expired on: {{ site.inductionForSite.expiryDate | date : 'mediumDate' }}</span>
                            <ng-container *ngIf="routeRole === 'contractor-manager'">
                              <ng-template *ngTemplateOutlet="reminderButton; context: { workerSite: site }"></ng-template>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="site.site.siteInductionCourse && !site.inductionForSite">
                            <span class="badge badge-pill badge-danger">Not Passed</span>
                            <ng-container *ngIf="routeRole === 'contractor-manager'">
                              <ng-template *ngTemplateOutlet="reminderButton; context: { workerSite: site }"></ng-template>
                            </ng-container>
                          </ng-container>
                          <span *ngIf="!site.site.siteInductionCourse" class="badge badge-pill badge-default">None required</span>

                          <ng-template #reminderButton let-workerSite="workerSite">
                            <div>
                              <button
                                type="button"
                                class="btn btn-primary btn-link"
                                [disabled]="workerSite.isSendingInductionReminder || workerSite.inductionReminderSent"
                                (click)="$event.stopPropagation(); resendInductionReminder(workerSite)"
                              >
                                <ng-container *ngIf="workerSite.isSendingInductionReminder">
                                  <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                  Sending...
                                </ng-container>
                                <ng-container *ngIf="!workerSite.isSendingInductionReminder">
                                  <span *ngIf="!workerSite.inductionReminderSent">Resend reminder</span>
                                  <span *ngIf="workerSite.inductionReminderSent">Reminder sent</span>
                                </ng-container>
                              </button>
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="3">No sites found</td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <br>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
